import { Select, SelectProps } from '@mantine/core';

import { useGetProvincesQuery } from '@api/locations.api';

export default function ProvinceSelector(props: SelectProps) {
  const { data = [], isLoading } = useGetProvincesQuery(undefined, {
    skip: props.disabled,
  });

  return (
    <Select
      label="Provincia"
      placeholder="Seleziona provincia"
      data={Array.from(
        new Map(
          data
            .toSorted((a, b) => (a.nome > b.nome ? 1 : -1))
            .map((province) => [province.sigla, province]),
        ).values(),
      ).map((province) => ({
        value: province.sigla,
        label: province.nome,
      }))}
      searchable
      {...props}
      disabled={isLoading || props.disabled}
    />
  );
}
